import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import HeroContent from './HeroContent';
import classNames from 'classnames';
import { useMediaQueries } from '@hooks';
import { motion } from 'motion/react';

export default function Hero(props) {
  const {
    isHero = false,
    title = 'Cibo&Cultura',
    label = null,
    description,
    video,
    cta = null,
    slides,
    hasSlider = slides?.length > 0 || true,
    img,
    isBanner = false,
  } = props;
  const { isMobile } = useMediaQueries();
  const sliderRef = useRef(null);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (sliderRef.current?.splide) {
      sliderRef.current.splide.on('active', (a) => {
        setIndex(a?.index);
      });
    }
  }, [sliderRef]);
  return (
    <div
      className={classnames(
        'bg-neutral banner',
        'w-full',
        !isBanner && 'px-2 sm:px-4 lg:px-16',
        ' relative z-20',
        'flex flex-col overflow-hidden ',
        'items-center justify-center',
      )}
    >
      {hasSlider ? (
        <Splide
          tag="section"
          ref={sliderRef}
          options={{
            drag: slides?.length > 1,
            type: 'slide',
            width: '100%',
            height: '100%',
            autoplay: true,
            pagination: isBanner && isMobile && slides?.length > 1,
            arrows: isBanner && !isMobile && slides?.length > 1,
            padding: 0,
            rewind: true,
            snap: true,
            perPage: 1,
            perMove: 1,
            focus: 0,
            flickPower: 800,
            flickMaxPages: 1,
            lazyLoad: 'nearby',
            video: {
              loop: true,
              mute: true,
            },
          }}
        >
          {slides?.length > 0 &&
            slides?.map((slide, i) => {
              return (
                <SplideSlide
                  key={i}
                  className={classnames(
                    'relative',
                    'w-full',
                    'z-10 rounded-t-sm md:rounded-sm',
                    'h-[35vh] md:h-[50vh] lg:h-[40vw]',
                    'centered',
                  )}
                >
                  <HeroContent
                    {...slide}
                    isHero={isHero}
                    isBanner={isBanner}
                    slideMode={true}
                    isActive={index === i}
                    singleAnimationIn={false}
                  />
                </SplideSlide>
              );
            })}
        </Splide>
      ) : (
        <HeroContent
          isBanner={isBanner}
          isActive={false}
          slideMode={false}
          singleAnimationIn={true}
          {...{
            img,
            video,
            isBanner,
            title,
            label,
            description,
            cta,
          }}
        />
      )}

      {!isBanner && (
        <div className="relative bg-primary w-full md:w-[87vw] lg:w-4/5 text-neutral-50 -mt-1 md:-translate-y-1/2 z-20 md:py-8 px-4 py-5 md:px-12 rounded-b md:rounded space-y-2 text-center md:text-start">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className={classNames('leading-none', 'label')}
            >
              {label}
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className={classNames('leading-none', 'h1')}
            >
              {title}
            </motion.h1>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            {description}
          </motion.p>
          {cta && (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
            >
              {cta}
            </motion.div>
          )}
        </div>
      )}
    </div>
  );
}
